import { FC } from "react";
import { ColSize, ContentSection, InputForm, RowSize } from "../../../../../../../shared/components";
import { IntermediaryInformation } from "../../../../../../../shared/interfaces/services/get-producer-information-service";

interface AddressInfoFormProperties {
    intermediaryInformation: IntermediaryInformation;
}

export const AddressInfoForm: FC<AddressInfoFormProperties> = ({intermediaryInformation}) => {
    const {
        pais,
        provincia,
        localidad,
        codigoPostal,
        domicilio,
    } = intermediaryInformation;
    
    const formItems: { label: string; name: string; size: 75 | 25; initialValue?: string }[] = [
        { label: "País", name: "country", size: 25, initialValue: pais },
        { label: "Provincia", name: "province", size: 25, initialValue: provincia},
        { label: "Localidad", name: "city", size: 25, initialValue: localidad},
        { label: "Domicilio", name: "address", size: 25, initialValue: domicilio},
        { label: "Codigo Postal", name: "zipCode", size: 25, initialValue: codigoPostal},
      ];

    return (
        <div id="domicilio">
            <ContentSection level='h3' title='Domicilio'>
                <RowSize>
                    {formItems.map(({ label, name, size, initialValue }) => (
                        <ColSize key={name} size={size}>
                            <InputForm
                                formProps={{
                                    label: label,
                                    name: name,
                                    initialValue: initialValue
                                }}
                                inputProps={{ placeholder: label, disabled: true }}
                            />
                        </ColSize>
                    ))}
                </RowSize>
            </ContentSection>
        </div>
    )
}
